import { render, staticRenderFns } from "./SystemInformModal.Style#Drawer.vue?vue&type=template&id=16c247cc&scoped=true"
import script from "./SystemInformModal.Style#Drawer.vue?vue&type=script&lang=js"
export * from "./SystemInformModal.Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./SystemInformModal.Style#Drawer.vue?vue&type=style&index=0&id=16c247cc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c247cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c247cc')) {
      api.createRecord('16c247cc', component.options)
    } else {
      api.reload('16c247cc', component.options)
    }
    module.hot.accept("./SystemInformModal.Style#Drawer.vue?vue&type=template&id=16c247cc&scoped=true", function () {
      api.rerender('16c247cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/systemInform/modules/SystemInformModal.Style#Drawer.vue"
export default component.exports